// extracted by mini-css-extract-plugin
export var borderRadius = "_5a-4";
export var large = "_5a-3";
export var logoContainer = "_5a-0";
export var nameLogo = "_5a-2";
export var small = "_5a-1";